export default __webpack_public_path__ + "static/majestic-ireland-screenshot-homepage-desktop-video-poster-daeaad4486b90a2669a092d7f598b206.jpg";